import { Entity } from "./entity";
import { MobileDevice } from "./enum-type";

export interface User extends Entity {
  firstname?: string
  lastname?: string
  username?: string
  password?: string
  email: string
  telephone?: string
  mobile?: string
  fonction?: string
  technical?: boolean
  avatar?: string
  fullName?: string
  roles?: string[]
  assignedMobileDevice?: MobileDevice
  locked?: boolean
}

export class UserExport {
  usrs: User[]
}

export function getUserExport(users: User[]): UserExport {
  const userExport = new UserExport();
  userExport.usrs = users;
  return userExport;
}